import type { KinnserUploadFileSummary } from '../../hooks/useCreatePatientForm/useKinnserUploadStatusPolling';

/**
 * Per-file lines under a Kinnser schedule/auto-add success message: how
 * many documents landed, and WellSky's reason for each one it rejected.
 */
export function KinnserUploadSummaryLines({
  summary,
}: {
  summary: KinnserUploadFileSummary;
}) {
  const { attachedCount, rejectedReasons } = summary;
  return (
    <div className='mt-2 space-y-1 text-sm'>
      <div className='text-green-700'>
        {attachedCount} document{attachedCount === 1 ? '' : 's'} attached
      </div>
      {rejectedReasons.length > 0 && (
        <div className='mt-2 p-2 bg-amber-50 border border-amber-200 rounded-md text-amber-800'>
          <div className='font-medium'>WellSky rejected:</div>
          <ul className='list-disc list-inside space-y-1'>
            {rejectedReasons.map((reason, i) => (
              <li key={i} className='break-words'>
                {reason}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
